export const MX_DOMAIN_EXTENSION = '.mx'
export const ES_DOMAIN_EXTENSION = '.es'


// WEBPACK FOOTER //
// ./src/constants/domainExtensions.js